import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  id?: string;
  collapsing?: boolean;
  thin?: boolean;
  stackable?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  textAlign?: 'left' | 'right' | 'center';
  wrap?: boolean;
  href?: string;
  onClick?: () => void;
  colSpan?: number | string;
  children?: React.ReactNode;
  verticalAlign?: 'top' | 'middle' | 'bottom' | 'baseline';
};

function TableCell({
  id,
  collapsing = false,
  thin = false,
  stackable = true,
  onMouseEnter,
  onMouseLeave,
  textAlign = 'left',
  wrap = false,
  children = '',
  href,
  colSpan,
  onClick,
  verticalAlign,
}: Props) {
  const classNames = ['text-sm', 'text-gray-600', 'relative'];

  if (wrap) {
    classNames.push('whitespace-normal');
  } else {
    classNames.push('whitespace-nowrap');
  }

  if (thin) {
    classNames.push('px-3', 'py-4');
  } else {
    classNames.push('px-6', 'py-4');
  }

  if (stackable) {
    classNames.push('md:table-cell', 'block');
  } else {
    classNames.push('table-cell');
  }

  if (textAlign === 'right') {
    classNames.push('text-right');
  } else if (textAlign === 'center') {
    classNames.push('text-center');
  } else {
    classNames.push('text-left');
  }

  if (collapsing) {
    classNames.push('w-px');
  }

  switch (verticalAlign) {
    case 'top':
      classNames.push('align-top');
      break;
    default:
    case 'middle':
      classNames.push('align-middle');
      break;
    case 'bottom':
      classNames.push('align-bottom');
      break;
    case 'baseline':
      classNames.push('align-baseline');
      break;
  }

  if (onClick) {
    classNames.push('cursor-pointer');
  }

  if (href) {
    return (
      <Link
        id={id}
        to={href}
        className={classNames.join(' ')}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </Link>
    );
  }

  return (
    <td
      id={id}
      className={classNames.join(' ')}
      colSpan={colSpan}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </td>
  );
}

export default TableCell;
